import { useSelector } from 'react-redux';
import FileSelector from './FileSelector';
import Button from '../ui/Button';

import './AddDocumentsForm.scss';

const AddDocumentsForm = ({
	docsConfirmLabel,
	onDocsConfirm,
	onBack,
	informedConsentEntered
}) => {
	let informedConsentFormLabel = 'Informed Consent Form';
	// bring all the files uploaded by the user that were stored in the slice
	const fileSlice = useSelector(
		(state) => state.filesManager.files
	);

	const findProtocol = fileSlice.filter(
		(file) => file.documentType === 'protocol'
	);
	const findInformedconsent = fileSlice.filter(
		(file) => file.documentType === 'informedConsentForm'
	);
	// btn is only activated when a protocol file exists (because protocol is mandatory)
	const thereIsProtocol =
		findProtocol.length >= 1 ? true : false;

	const thereIsInformedconsent =
		findInformedconsent.length >= 1 ? true : false;

	let validForm = thereIsProtocol;

	if (informedConsentEntered) {
		informedConsentFormLabel = 'Informed Consent Form*';
		validForm = thereIsProtocol && thereIsInformedconsent;
	}
	return (
		<div>
			<FileSelector
				title='Protocol*'
				label='Upload the study protocol.'
				multiple={false}
				documentType='protocol'
			></FileSelector>
			<FileSelector
				title={informedConsentFormLabel}
				label='Upload the most recent Informed Consent Form, if available.'
				multiple={false}
				documentType='informedConsentForm'
			></FileSelector>
			<FileSelector
				title='Budget'
				label='Upload the most current budget, if available.'
				multiple={false}
				documentType='budget'
			></FileSelector>
			<FileSelector
				title='Other Documents'
				label='Upload additional documents to support the Coverage Analysis. Do not upload the documents submitted above.'
				multiple={true}
				documentType='otherDocuments'
			></FileSelector>
			<div className='text-center file-selector-controllers'>
				<Button
					onClick={onBack}
					className='secondary-button'
				>
					Back
				</Button>
				<Button
					onClick={onDocsConfirm}
					className='primary-button'
					disabled={!validForm}
				>
					{docsConfirmLabel}
				</Button>
			</div>
		</div>
	);
};
export default AddDocumentsForm;
